import anchorAnimate from './modules/anchor-animate';
import mobMenuDropdowns from './modules/mob-menu-dropdowns';
import setPageMinHeight from './modules/set-page-min-height';
import utmTracking from './modules/utm-tracking';

( function ( $ ) {
    'use strict';

    $( function() {
        anchorAnimate.init();
        mobMenuDropdowns.init();
        setPageMinHeight.init();
        utmTracking.init();
    } );

} )( jQuery );
